import VideoView from './VideoView';

export default class YoutubeListView extends VideoView {

    createView(model) {

        let libraryCatalog = model['libraryCatalog'];

        let libraryDOM = super.createView(model);

        let iframeContainer = $('<div>', {
            class: 'iframe-container'
        }).appendTo(libraryDOM);
        
        $('<iframe>', {
            'src': libraryCatalog.url
        }).appendTo(iframeContainer);

        return libraryDOM;

    }

}
